import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import '../Styles/FriendMenuDropdown.css';

const FriendMenuDropdown = ({ isOpen, onClose, items, className, anchorRef }) => {
  const dropdownRef = useRef(null);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  // Calculate position based on anchor element
  useEffect(() => {
    if (!isOpen || !anchorRef?.current) return;

    const updatePosition = () => {
      const rect = anchorRef.current.getBoundingClientRect();
      setPosition({
        top: rect.bottom + window.scrollY + 8, // 8px gap below button
        left: rect.right + window.scrollX - 200, // Align to right (200px = dropdown width)
      });
    };

    updatePosition();
    window.addEventListener('scroll', updatePosition);
    window.addEventListener('resize', updatePosition);

    return () => {
      window.removeEventListener('scroll', updatePosition);
      window.removeEventListener('resize', updatePosition);
    };
  }, [isOpen, anchorRef]);

  // Close on click outside
  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        anchorRef.current &&
        !anchorRef.current.contains(event.target)
      ) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, onClose, anchorRef]);

  if (!isOpen) return null;

  // Render dropdown using Portal (outside parent container)
  return createPortal(
    <div 
      ref={dropdownRef}
      className={`frn-menu-dropdown ${className || ''}`}
      style={{
        position: 'fixed', // ⭐ Changed to fixed for portal
        top: `${position.top}px`,
        left: `${position.left}px`,
        zIndex: 9999, // ⭐ Very high z-index
        minWidth: '50px',
        background: "rgb(34, 31, 31) "
      }}
    >
      {items.map((item, index) => (
        <div
          key={index}
          className="frn-menu-dropdown-item"
          onClick={() => {
            item.action();
            onClose();
          }}
        >
          {item.label}
        </div>
      ))}
    </div>,
    document.body // ⭐ Render at body level
  );
};

export default FriendMenuDropdown;